<template>
<div class="chapter">
<div class="inner_page">
<p class="break c"> </p>
<p class="title z"><b>THE OKLAHOMA <br/>
PREPPER</b></p>
<p class="title1 d"><b>Your Ultimate Survival Guide</b></p>
<p class="title2 c"><b>Matthew E. Sheets</b></p>
<p class="image z"><img alt="logo.jpg" src="html/images/logo.jpg" style="width: 110px"/></p>
<p class="title3 z"><a href="http://www.TotalPublishingAndMedia.com" target="_blank">www.TotalPublishingAndMedia.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_title.vue?53c813d7